import { ServiceBoat } from './../../../../models/service-boat';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from 'primeng/dynamicdialog';
import { ServiceBoatReadjustmentDTO } from 'src/app/models/dtos/service-boat-readjustmentDTO';
import { ServiceCustomerReadjustmentDTO } from 'src/app/models/dtos/service-customer-readjustmentDTO';
import { servicesReadjustmentRegisterPriceFreeDTO } from 'src/app/models/dtos/services-readjustment-register-price-freeDTO';
import { servicesReadjustmentRegisterPriceFreeCustomerDTO } from 'src/app/models/dtos/services-readjustment-register-price-free-customerDTO';
import { ReadjustmentType } from 'src/app/models/enums/readjustment-type';
import { BoatService } from 'src/app/services/boat.service';
import { CustomerService } from 'src/app/services/customer.service';
import { ProductService } from 'src/app/services/product.service';
import { ServiceBoatService } from 'src/app/services/service-boat.service';
import { ServiceCustomerService } from 'src/app/services/service-customer.service';
import { ToastService } from 'src/app/services/toast.service';
import { DeepCloneUtil } from 'src/app/utils/deep-clone.util';
import { FormatUtil } from 'src/app/utils/format.util';
import { MessageUtil } from 'src/app/utils/message.util';
import { ShipType } from 'src/app/models/ship-type';
import Swal from 'sweetalert2';
import { SlingConfig } from 'src/app/models';
import { ReajustmentHistoricComponent } from './reajustment-historic/reajustment-historic/reajustment-historic.component';
import { BroadcastService } from 'src/app/services/broadcast.service';

@Component({
  selector: 'app-list-price-free',
  templateUrl: './list-price-free.component.html',
  styleUrls: ['./list-price-free.component.scss'],
})
export class ListPriceFreeComponent implements OnInit {
  @Output() exportList = new EventEmitter<any[]>();

  @Input() slingConfig: SlingConfig;
  filteredCustomers: any[] = [];
  filteredBoats: any[] = [];
  filteredServicesInUse: any[] = [];
  selectedServices: any[] = [];
  servicesOriginal: ServiceBoatReadjustmentDTO[] = [];
  services: ServiceBoatReadjustmentDTO[] = [];
  servicesCustomer: ServiceCustomerReadjustmentDTO[] = [];
  servicesCustomerOriginal: ServiceCustomerReadjustmentDTO[] = [];
  filter: any = {};

  readjustmentTypes: { label: string; value: string }[] = [];
  adjustmentForm: UntypedFormGroup;
  isBoatService: boolean = true; // true = Serviços de Embarcações, false = Serviços de Cliente

  totalValues = 0;
  totalDiscounts = 0;
  totalDueDateDiscounts = 0;
  totalReadjustmentsValues = 0;
  totalReadjustmentsDiscounts = 0;
  totalReadjustmentsDueDateDiscounts = 0;

  constructor(
    private customerService: CustomerService,
    private boatService: BoatService,
    private productService: ProductService,
    private serviceBoatService: ServiceBoatService,
    private serviceCustomerService: ServiceCustomerService,
    public dialog: DialogService,
    private spinner: NgxSpinnerService,
    private toasty: ToastService,
    private messageUtil: MessageUtil
  ) {}

  ngOnInit(): void {
    this.getTypes();
    this.getCustomers();
    this.getBoats();
    this.getPeriodicalServiceInUse();
    this.startForm();
  }

  changeType():void{
    this.getCustomers();
    this.getPeriodicalServiceInUse();
  }

  startForm() {
    this.adjustmentForm = new UntypedFormGroup({
      percentage: new UntypedFormControl(
        null,
        Validators.compose([Validators.required])
      ),
      readjustmentType: new UntypedFormControl(
        null,
        Validators.compose([Validators.required])
      ),
      diasReajuste: new UntypedFormControl(
        12,
        Validators.compose([Validators.required])
      ),
    });
  }

  getTypes() {
    this.readjustmentTypes = Object.keys(ReadjustmentType).map((item) => ({
      label: item,
      value: item,
    }));
  }

  getCustomers(): void {
    if (this.isBoatService){
      this.customerService.getPeriodicalServiceInUse().subscribe((data) => {
        this.filteredCustomers = [{ label: 'Todos', value: null }].concat(
          data.map((c) => ({
            label: c.name + (c.active ? '' : ' (inativo)'),
            value: c.id,
          }))
        );
      });
    }else{
      this.customerService.getPeriodicalCustomerServiceInUse().subscribe((data) => {
        this.filteredCustomers = [{ label: 'Todos', value: null }].concat(
          data.map((c) => ({
            label: c.name + (c.active ? '' : ' (inativo)'),
            value: c.id,
          }))
        );
      });
    }
  }

  getBoats(): void {
    this.boatService
      .getBoatsWithPeriodicalServicePriceFreeInUse()
      .subscribe((data) => {
        this.filteredBoats = [{ label: 'Todos', value: null }].concat(
          data
            .filter((boat) => boat.active)
            .map((b) => ({ label: b.name, value: b.id }))
        );
      });
  }

  getPeriodicalServiceInUse(): void {
    if (this.isBoatService){
    this.productService
      .getPeriodicalServicePriceFreeInUseFilterList()
      .subscribe((data) => {
        this.filteredServicesInUse = [{ label: 'Todos', value: null }].concat(
          data.map((serviceInUse) => ({
            label: serviceInUse.name,
            value: serviceInUse.id,
          }))
        );
      });
    }else{
      this.productService
      .getPeriodicalServiceToCustomerPriceFreeInUseFilterList()
      .subscribe((data) => {
        this.filteredServicesInUse = [{ label: 'Todos', value: null }].concat(
          data.map((serviceInUse) => ({
            label: serviceInUse.name,
            value: serviceInUse.id,
          }))
        );
      });

    }
  }

  getImageShipType(shipType: ShipType): string {
    return '/assets/images/'.concat(shipType).concat('.png');
  }

  clear() {
    this.filter = {};
  }

  search() {
    if (this.isBoatService){
      this.findServicesBoat();
    }else{
      this.findServicesCustomer();
    }
  }

  save() {
    if (this.isBoatService) {
      const servicesReadjustment: servicesReadjustmentRegisterPriceFreeDTO[] =
        this.services
          .filter((s) => s.readjustmentValue)
          .map((s) => ({
            serviceBoatId: s.serviceBoatId,
            value: s.readjustmentValue,
            discount: s.readjustmentDiscount,
            dueDateDiscount: s.readjustmentDueDateDiscount,
            newEndService: s.newEndService,
            indexUsed: this.adjustmentForm.get('percentage').value,
            indexUsedText: this.slingConfig.indexUsed,
          }));
      Swal.fire({
        title: 'Registrar reajuste',
        text:
          'Desejas realizar o reajuste de ' +
          servicesReadjustment.length +
          ' mensalidade' +
          (servicesReadjustment.length > 1 ? 's' : '') +
          '?',
        icon: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Confirmar',
      }).then((response) => {
        if (response.value) {
          this.sendReadjustments(servicesReadjustment);
        }
      });
    } else {
      const servicesReadjustment: servicesReadjustmentRegisterPriceFreeCustomerDTO[] =
        this.servicesCustomer
          .filter((s) => s.readjustmentValue)
          .map((s) => ({
            serviceCustomerId: s.serviceCustomerId,
            value: s.readjustmentValue,
            discount: s.readjustmentDiscount,
            dueDateDiscount: s.readjustmentDueDateDiscount,
            newEndService: s.newEndService,
            indexUsed: this.adjustmentForm.get('percentage').value,
            indexUsedText: this.slingConfig.indexUsed,
          }));
      Swal.fire({
        title: 'Registrar reajuste',
        text:
          'Desejas realizar o reajuste de ' +
          servicesReadjustment.length +
          ' mensalidade' +
          (servicesReadjustment.length > 1 ? 's' : '') +
          '?',
        icon: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Confirmar',
      }).then((response) => {
        if (response.value) {
          this.sendReadjustmentsCustomer(servicesReadjustment);
        }
      });
    }
  }

  async sendReadjustments(
    readjustment: servicesReadjustmentRegisterPriceFreeDTO[]
  ): Promise<void> {
    return new Promise((resolve) => {
      this.spinner.show();
      this.serviceBoatService
        .registerReadjustmentPriceFree(readjustment)
        .subscribe(
          (data) => {
            this.toasty.success('Reajuste realizado com sucesso');
            this.spinner.hide();
            this.findServicesBoat();
            resolve();
          },
          (error) => {
            const exception = error.error.data.exception;
            this.messageUtil.generateMessage(
              exception.type,
              exception.title,
              exception.message
            );
            this.spinner.hide();
            resolve();
          }
        );
    });
  }

  async sendReadjustmentsCustomer(
    readjustment: servicesReadjustmentRegisterPriceFreeCustomerDTO[]
  ): Promise<void> {
    return new Promise((resolve) => {
      this.spinner.show();
      this.serviceCustomerService
        .registerReadjustmentPriceFree(readjustment)
        .subscribe(
          (data) => {
            this.toasty.success('Reajuste realizado com sucesso');
            this.spinner.hide();
            this.findServicesCustomer();
            resolve();
          },
          (error) => {
            const exception = error.error.data.exception;
            this.messageUtil.generateMessage(
              exception.type,
              exception.title,
              exception.message
            );
            this.spinner.hide();
            resolve();
          }
        );
    });
  }

  clearAdjustments() {
    if (this.isBoatService) {
      this.services = DeepCloneUtil.clone(this.servicesOriginal);
    } else {
      this.servicesCustomer = DeepCloneUtil.clone(this.servicesCustomerOriginal);
    }
    this.selectedServices = [];
    this.calcTotals();
  }

  readjustment() {
    if (this.isBoatService) {
      // Reajuste para serviços de embarcações
      this.selectedServices.forEach((service: ServiceBoatReadjustmentDTO) => {
        service.readjustmentDiscount = service.discount;
        service.readjustmentDueDateDiscount = service.dueDateDiscount;
        if (service.contractEndDate) {
          service.newEndService = this.newEndServiseAjustement(
            service.contractEndDate,
            this.adjustmentForm.get('diasReajuste').value
          );
        }
      });
      this.addReajustmentValue(
        this.selectedServices as ServiceBoatReadjustmentDTO[],
        this.adjustmentForm.get('percentage').value
      );
      if (this.adjustmentForm.get('readjustmentType').value === 'VALUEDISCOUNT') {
        this.addReajustmentDiscount(
          this.selectedServices as ServiceBoatReadjustmentDTO[],
          this.adjustmentForm.get('percentage').value
        );
        this.addReajustmentDueDateDiscount(
          this.selectedServices as ServiceBoatReadjustmentDTO[],
          this.adjustmentForm.get('percentage').value
        );
      }
      this.exportList.emit(this.services);
    } else {
      // Reajuste para serviços de cliente
      this.selectedServices.forEach((service: ServiceCustomerReadjustmentDTO) => {
        service.readjustmentDiscount = service.discount;
        service.readjustmentDueDateDiscount = service.dueDateDiscount;
        if (service.contractEndDate) {
          service.newEndService = this.newEndServiseAjustement(
            service.contractEndDate,
            this.adjustmentForm.get('diasReajuste').value
          );
        }
      });
      this.addReajustmentValueCustomer(
        this.selectedServices as ServiceCustomerReadjustmentDTO[],
        this.adjustmentForm.get('percentage').value
      );
      if (this.adjustmentForm.get('readjustmentType').value === 'VALUEDISCOUNT') {
        this.addReajustmentDiscountCustomer(
          this.selectedServices as ServiceCustomerReadjustmentDTO[],
          this.adjustmentForm.get('percentage').value
        );
        this.addReajustmentDueDateDiscountCustomer(
          this.selectedServices as ServiceCustomerReadjustmentDTO[],
          this.adjustmentForm.get('percentage').value
        );
      }
    }
    this.calcTotals();
  }

  showHide(): void {
    BroadcastService.get('showHideSidenav').emit(false);
  }

  removeReajustment(service: ServiceBoatReadjustmentDTO | ServiceCustomerReadjustmentDTO) {
    service.readjustmentValue = undefined;
    service.readjustmentDiscount = undefined;
    service.readjustmentDueDateDiscount = undefined;
    this.calcTotals();
  }

  totalReajustment(service: ServiceBoatReadjustmentDTO | ServiceCustomerReadjustmentDTO): number {
    if (service.readjustmentValue) {
      return (
        service.readjustmentValue -
        (service.readjustmentDiscount || 0) -
        (service.readjustmentDueDateDiscount || 0)
      );
    }
    return;
  }

  totalOldValue(service: ServiceBoatReadjustmentDTO | ServiceCustomerReadjustmentDTO): number {
    return service.value - service.discount - service.dueDateDiscount;
  }

  differenceReajustment(service: ServiceBoatReadjustmentDTO | ServiceCustomerReadjustmentDTO): number {
    if (service.readjustmentValue) {
      return this.totalReajustment(service) - this.totalOldValue(service);
    }
    return;
  }

  newEndServiseAjustement(dtAtual: Date, meses: number): Date {
    if (dtAtual) {
      let newDate: Date = new Date(dtAtual);
      newDate.setMonth(new Date(dtAtual).getMonth() + meses);
      return new Date(
        new Date(newDate).getFullYear(),
        new Date(newDate).getMonth() + 1,
        0
      );
    }
    return;
  }

  private addReajustmentValue(
    services: ServiceBoatReadjustmentDTO[],
    percentage: number
  ) {
    services.forEach((service) => {
      service.readjustmentValue =
        service.value +
        FormatUtil.roundTwoDecimal(service.value * (percentage / 100));
    });
  }

  private addReajustmentDiscount(
    services: ServiceBoatReadjustmentDTO[],
    percentage: number
  ) {
    services.forEach((service) => {
      service.readjustmentDiscount = FormatUtil.roundTwoDecimal(
        service.discount +
          FormatUtil.roundTwoDecimal(service.discount * (percentage / 100))
      );
    });
  }

  private addReajustmentDueDateDiscount(
    services: ServiceBoatReadjustmentDTO[],
    percentage: number
  ) {
    services.forEach((service) => {
      service.readjustmentDueDateDiscount = FormatUtil.roundTwoDecimal(
        service.dueDateDiscount +
          FormatUtil.roundTwoDecimal(
            service.dueDateDiscount * (percentage / 100)
          )
      );
    });
  }

  // Métodos para serviços de cliente
  private addReajustmentValueCustomer(
    services: ServiceCustomerReadjustmentDTO[],
    percentage: number
  ) {
    services.forEach((service) => {
      service.readjustmentValue =
        service.value +
        FormatUtil.roundTwoDecimal(service.value * (percentage / 100));
    });
  }

  private addReajustmentDiscountCustomer(
    services: ServiceCustomerReadjustmentDTO[],
    percentage: number
  ) {
    services.forEach((service) => {
      service.readjustmentDiscount = FormatUtil.roundTwoDecimal(
        service.discount +
          FormatUtil.roundTwoDecimal(service.discount * (percentage / 100))
      );
    });
  }

  private addReajustmentDueDateDiscountCustomer(
    services: ServiceCustomerReadjustmentDTO[],
    percentage: number
  ) {
    services.forEach((service) => {
      service.readjustmentDueDateDiscount = FormatUtil.roundTwoDecimal(
        service.dueDateDiscount +
          FormatUtil.roundTwoDecimal(
            service.dueDateDiscount * (percentage / 100)
          )
      );
    });
  }

  enableApllyPorcentagemSelectedService(): boolean {
    return this.selectedServices?.length < 1 || this.adjustmentForm.invalid;
  }

  enableSendEmails(): boolean {
    return this.selectedServices?.length < 1;
  }

  enableReadjustment(): boolean {
    if (this.isBoatService) {
      return this.services.filter((s) => s.readjustmentValue).length > 0;
    } else {
      return this.servicesCustomer.filter((s) => s.readjustmentValue).length > 0;
    }
  }

  async findServicesBoat(): Promise<void> {
    return new Promise((resolve) => {
      this.spinner.show();
      this.serviceBoatService.getServicesBoatPriceFree(this.filter).subscribe(
        (data) => {
          this.selectedServices = [];
          this.services = data;
          this.servicesOriginal = DeepCloneUtil.clone(data);
          this.calcTotals();
          this.spinner.hide();
          resolve();
        },
        (error) => {
          this.spinner.hide();
          resolve();
        }
      );
    });
  }


  async findServicesCustomer(): Promise<void> {
    return new Promise((resolve) => {
      this.spinner.show();
      this.customerService.getServicesCustomerPriceFree(this.filter).subscribe(
        (data) => {
          this.selectedServices = [];
          this.servicesCustomer = data;
          this.servicesCustomerOriginal = DeepCloneUtil.clone(data);
          this.calcTotals();
          this.spinner.hide();
          resolve();
        },
        (error) => {
          this.spinner.hide();
          resolve();
        }
      );
    });
  }


  calcTotals() {
    this.totalValues = 0;
    this.totalDiscounts = 0;
    this.totalDueDateDiscounts = 0;
    this.totalReadjustmentsValues = 0;
    this.totalReadjustmentsDiscounts = 0;
    this.totalReadjustmentsDueDateDiscounts = 0;

    if (this.isBoatService && this.services) {
      this.services
        .filter((service) => service.readjustmentValue)
        .forEach((service) => {
          this.totalValues += service.value;
          this.totalDiscounts += service.discount;
          this.totalDueDateDiscounts += service.dueDateDiscount;
          this.totalReadjustmentsValues += service.readjustmentValue;
          this.totalReadjustmentsDiscounts += service.readjustmentDiscount || 0;
          this.totalReadjustmentsDueDateDiscounts +=
            service.readjustmentDueDateDiscount || 0;
        });
    } else if (!this.isBoatService && this.servicesCustomer) {
      this.servicesCustomer
        .filter((service) => service.readjustmentValue)
        .forEach((service) => {
          this.totalValues += service.value;
          this.totalDiscounts += service.discount;
          this.totalDueDateDiscounts += service.dueDateDiscount;
          this.totalReadjustmentsValues += service.readjustmentValue;
          this.totalReadjustmentsDiscounts += service.readjustmentDiscount || 0;
          this.totalReadjustmentsDueDateDiscounts +=
            service.readjustmentDueDateDiscount || 0;
        });
    }
  }

  calcTotalValueTotal(): number {
    const totalValuesTotal = this.totalValues - this.totalDiscounts;
    return totalValuesTotal > 0 ? totalValuesTotal : 0;
  }

  calcReadjustementTotalValueTotal(): number {
    const totalValuesTotal =
      this.totalReadjustmentsValues -
      this.totalReadjustmentsDiscounts -
      this.totalReadjustmentsDueDateDiscounts;
    return totalValuesTotal > 0 ? totalValuesTotal : 0;
  }

  differenceTotals(): number {
    return (
      this.totalReadjustmentsValues -
      this.totalValues -
      (this.totalReadjustmentsDiscounts - this.totalDiscounts) -
      (this.totalReadjustmentsDueDateDiscounts - this.totalDueDateDiscounts)
    );
  }

  calcTotalDiscountsReadjustments(): void {
    let total: number = 0;
    if (this.services) {
      total = this.services
        .map((s) => (s.readjustmentDiscount ? s.readjustmentDiscount : 0))
        .reduce((total, value) => {
          return (total += value);
        }, 0);
    }
    this.totalReadjustmentsDiscounts = total;

    this.exportList.emit(this.services);
  }

  calcTotalDueDateDiscountsReadjustments(): void {
    let total: number = 0;
    if (this.services) {
      total = this.services
        .map((s) =>
          s.readjustmentDueDateDiscount ? s.readjustmentDueDateDiscount : 0
        )
        .reduce((total, value) => {
          return (total += value);
        }, 0);
    }
    this.totalReadjustmentsDueDateDiscounts = total;

    this.exportList.emit(this.services);
  }

  confirmSendEmail(): void {
    if (this.selectedServices?.length <= 0) {
      return;
    }
    Swal.fire({
      title: 'Envio de Email',
      text: 'Confirma o envio de emails para os proprietários das embarcações selecionadas?',
      icon: 'warning',
      reverseButtons: true,
      showCancelButton: true,
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Confirmar',
    }).then((response) => {
      if (response.value) {
        this.sendEmails(this.selectedServices);
      }
    });
  }

  async sendEmails(servicesSelect: any[]): Promise<void> {
    return new Promise((resolve) => {
      this.spinner.show();
      if (this.isBoatService) {

      this.serviceBoatService.sendEmailsReajustment(servicesSelect).subscribe(
        (data) => {
          this.spinner.hide();
          const sendError: string[] = data;
          if (sendError.length > 0) {
            let mensagem = '';
            sendError.forEach((currentValue) => {
              mensagem = mensagem + currentValue + ' \n';
            });
            this.messageUtil.generateMessage(
              'warning',
              'Envio de Email',
              mensagem
            );
          } else {
            this.messageUtil.generateMessage(
              'success',
              'Envio de Email',
              'Todos os e-mails foram enviados com sucesso!'
            );
          }
          resolve();
        },
        (error) => {
          const exception = error.error.data.exception;
          this.messageUtil.generateMessage(
            exception.type,
            exception.title,
            exception.message
          );
          this.spinner.hide();
          resolve();
        }
      );

    } else {
      this.serviceCustomerService.sendEmailsReajustment(servicesSelect).subscribe(
        (data) => {
          this.spinner.hide();
          const sendError: string[] = data;
          if (sendError.length > 0) {
            let mensagem = '';
            sendError.forEach((currentValue) => {
              mensagem = mensagem + currentValue + ' \n';
            });
            this.messageUtil.generateMessage(
              'warning',
              'Envio de Email',
              mensagem
            );
          } else {
            this.messageUtil.generateMessage(
              'success',
              'Envio de Email',
              'Todos os e-mails foram enviados com sucesso!'
            );
          }
          resolve();
        },
        (error) => {
          const exception = error.error.data.exception;
          this.messageUtil.generateMessage(
            exception.type,
            exception.title,
            exception.message
          );
          this.spinner.hide();
          resolve();
        }
      );
    }
    });
  }

  openHistoric(service: ServiceBoatReadjustmentDTO | ServiceCustomerReadjustmentDTO): void {
    const dialog = this.dialog.open(ReajustmentHistoricComponent, {
      dismissableMask: false,
      width: '75%',
      data: {
        service: service,
        isCustomerService: !this.isBoatService,
      },
      header: 'Histórico de Reajustes',
    });

    dialog.onClose.subscribe();
  }



  getBookColor(service: ServiceBoatReadjustmentDTO | ServiceCustomerReadjustmentDTO): string {
    if (
      !service.serviceHistoryReajustment ||
      service.serviceHistoryReajustment === null ||
      service.serviceHistoryReajustment.length === 0
    ) {
      return 'black-icon';
    }
    if (!service.serviceHistoryReajustment[0].sendEmail) {
      return 'red-icon';
    } else {
      return 'blue-icon';
    }
    //atencao eu pego a posicao 0 pois ela vem ordenada pelo maior ID com isso nao preciso checar se é o ultimo
  }
}
